module.exports = __webpack_public_path__ + "img/4064007290.6ee468bd.jpg";